/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { InjectionToken, inject } from '@angular/core';
import { DurationInMs } from '@shared/types/snapshots';
import { RxStomp } from '@stomp/rx-stomp';
import { CookieService } from 'ngx-cookie-service';
import { Observable, map, shareReplay } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MetricApiService } from './core/services/metric-definition-api.service';

export const WINDOW = new InjectionToken<Window>('Window', { providedIn: 'root', factory: () => window });
export const LOCAL_STORAGE = new InjectionToken<Storage>('Local storage', {
  providedIn: 'root',
  factory: () => localStorage,
});
export const IS_PRODUCTION = new InjectionToken<boolean>('Is production', {
  providedIn: 'root',
  factory: () => environment.production,
});
export const GA_TRACKING_ID = new InjectionToken<string>('Google Analytics tracking ID');
export const GA4_TRACKING_ID = new InjectionToken<string>('Google Analytics 4 tracking ID');
export const RX_STOMP = new InjectionToken('RxStomp', { providedIn: 'root', factory: () => new RxStomp() });
export const API_PORT = new InjectionToken('API port', {
  providedIn: 'root',
  factory: () => {
    const testPort = inject(CookieService).get('x-test-port');
    return testPort ? +testPort : null;
  },
});

export const METRICS_PULL_INTERVAL = new InjectionToken<Observable<DurationInMs>>('Metrics pull interval', {
  providedIn: 'root',
  factory: () => {
    return inject(MetricApiService)
      .metricsConfig()
      .pipe(
        map((config) => config.pullInterval),
        shareReplay({ refCount: false }),
      );
  },
});

export const LOCATION = new InjectionToken<Location>('Location', {
  providedIn: 'root',
  factory: () => inject(WINDOW).location,
});
